const RICS_FILTER_KEYS = [
  'rics_k10',
  'rics_k50',
  'rics_k400',
  'company',
] as const;

/**
 * Union the RICS/company id arrays of two request payloads.
 *
 * Company and Industry are separate filters that serialize through the same
 * keys, so a plain `{ ...acc, ...next }` lets whichever is reduced last replace
 * the other's ids instead of adding to them. Only keys present as arrays on
 * both sides are concatenated; everything else keeps spread semantics.
 */
export const mergeRicsFilterKeys = <T extends object>(
  acc: T,
  next: Partial<T>
): T => {
  const merged: Record<string, unknown> = { ...acc, ...next };

  for (const key of RICS_FILTER_KEYS) {
    const fromAcc = (acc as Record<string, unknown>)[key];
    const fromNext = (next as Record<string, unknown>)[key];
    if (Array.isArray(fromAcc) && Array.isArray(fromNext)) {
      merged[key] = [...fromAcc, ...fromNext];
    }
  }

  return merged as T;
};
